<template>
  <footer class="footer mt-auto py-2 bg-light">
    <div class="container container_wrapper">
      <span class="text-muted footer__text">
        <span class="footer__main">
          {{ $t('footer.copyright', { year }) }}
          <span v-if="version" class="text-muted"> | {{ $t('footer.version', { version }) }}</span>
          <span class="footer__legal">
            <span class="footer__sep"> | </span>
            <a
              class="footer__link"
              :href="imprintUrl"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t('footer.imprint') }}
            </a>
            <template v-if="dataPrivacyUrl">
              <span class="footer__sep"> | </span>
              <a
                class="footer__link"
                :href="dataPrivacyUrl"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ $t('footer.dataPrivacy') }}
              </a>
            </template>
          </span>
          <span v-if="showSwitcher" class="footer__language">
            <span class="footer__sep"> | </span>
            <button type="button" class="footer__link footer__language-btn" @click="openModal">
              {{ currentLanguageLabel }}
            </button>
          </span>
        </span>
      </span>
    </div>
    <LanguageSwitcherModal v-model="isModalOpen" />
  </footer>
</template>

<script>
import { ref, onMounted, toRef } from 'vue';
import { useFooterLegalLinks } from '@/composables/useFooterLegalLinks';
import { useLanguageSwitcher } from '@/composables/useLanguageSwitcher';
import LanguageSwitcherModal from '@/components/common/LanguageSwitcherModal.vue';

export default {
  components: { LanguageSwitcherModal },
  props: {
    journeyImprintUrl: {
      type: String,
      default: null,
    },
    journeyDataPrivacyUrl: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const year = new Date().getFullYear();
    const version = ref('');

    const { imprintUrl, dataPrivacyUrl } = useFooterLegalLinks(
      toRef(props, 'journeyImprintUrl'),
      toRef(props, 'journeyDataPrivacyUrl')
    );

    const { isModalOpen, showSwitcher, currentLanguageLabel, openModal } = useLanguageSwitcher();

    onMounted(async () => {
      try {
        const response = await fetch('/meta.json');
        if (!response.ok) {
          throw new Error('Failed to fetch version');
        }
        const data = await response.json();
        version.value = data.version;
      } catch (error) {
        console.error('Error loading version:', error);
      }
    });

    return {
      year,
      version,
      imprintUrl,
      dataPrivacyUrl,
      isModalOpen,
      showSwitcher,
      currentLanguageLabel,
      openModal,
    };
  },
};
</script>

<style lang="scss" scoped>
.footer__text {
  font-size: 0.75rem;
  line-height: 1.35;
}

.footer__link,
.footer__language-btn {
  font-size: inherit;
}

.footer__language-btn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: inherit;
  text-decoration: underline;
}
</style>
